export default "__VITE_ASSET__BAaP0hgn__"